/*!
 * @copyright
 * Copyright(c) 2019 SICK AG
 */
import { Viewport } from './Viewport';
/**
 * handles all viewports
 */
export class Viewports {
    constructor() {
        this._array = new Array();
        this._default = new Viewport(this, 'default', 'default', 'default', undefined);
    }
    /**
     * returns the default viewport
     */
    getDefault() {
        return this._default;
    }
    /**
     * returns the viewport by name
     * @param name
     */
    getByName(name) {
        return this._array.find((viewport) => viewport.name === name);
    }
    /**
     * returns the best fitting viewport that contains the position (x,y)
     * @param x
     * @param y
     * @param screenW
     * @param screenH
     */
    getByPosition(x, y, screenW, screenH) {
        let result;
        for (const viewport of this._array) {
            if (viewport.isIn(x, y, screenW, screenH)) {
                result = viewport;
            }
        }
        return result;
    }
    /**
     * creates viewports from an array of ViewportDescs
     * @param viewports
     */
    addFromDescriptions(...viewports) {
        let hasDefault = viewports.find((vp) => vp.name === 'default') !== undefined;
        let name = 'default';
        viewports.forEach((vpDesc, i) => {
            if (hasDefault) {
                name = 'default' + i;
            }
            else {
                hasDefault = true;
            }
            const vp = Viewport.fromDescription(this, vpDesc, name);
            this._array.push(vp);
        });
    }
    /**
     * iterator over all viewports
     * @param functor
     * @param orUseDefault if there is no viewport
     */
    forEachViewport(functor, orUseDefault = false) {
        if (this._array.length === 0 && orUseDefault) {
            functor(this._default);
        }
        else {
            this._array.forEach(functor);
        }
    }
    /**
     * call a functor only if a viewport with the name exists
     * @param name
     * @param functor
     */
    ifPresentDo(name, functor) {
        this._array.filter((vp) => vp.name === name).forEach(functor);
    }
}
//# sourceMappingURL=Viewports.js.map